import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";

import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";

import { FontAwesome } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";
import { SimpleLineIcons } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../_layout";
import { FontAwesome6 } from "@expo/vector-icons";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";

import { useTranslation } from "react-i18next";

const IconEmptyView = ({
  iconLibrary,
  iconName,
  mainText,
  subText,
  marginTop,
  marginBottom,
  ctaText,
  onCtaPress,
}) => {
  const [isCtaHovered, setIsCtaHovered] = useState(false);
  const screenSize = useScreenDimensions();
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  return (
    <View
      style={{
        width: "100%",
        alignItems: "center",
        flex: 1,
        justifyContent: "center",
        marginTop: marginTop ? marginTop : 0,
        marginBottom: marginBottom ? marginBottom : 0,
        padding: 16,
      }}
    >
      <View
        style={{
          alignItems: "center",
          marginBottom: 20,
          justifyContent: "center",
        }}
      >
        <View
          style={{
            width: 64,
            height: 64,
            borderRadius: 32,
            backgroundColor: Colors.bubbleColor,
            opacity: 0.06,
            position: "absolute",
          }}
        />
        <View
          style={{
            width: 48,
            height: 48,
            borderRadius: 24,
            backgroundColor: Colors.bubbleColor,
            opacity: 0.08,
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            position: "absolute",
          }}
        />
        <View
          style={{
            width: 48,
            height: 48,
            borderRadius: 24,
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "center",
            position: "absolute",
          }}
        >
          {iconLibrary === "Ionicons" ? (
            <Ionicons name={iconName} size={24} color={Colors.bubbleColor} />
          ) : iconLibrary === "FontAwesome5" ? (
            <FontAwesome5
              name="dumbbell"
              size={24}
              color={Colors.bubbleColor}
            />
          ) : iconLibrary === "FontAwesome6" ? (
            <FontAwesome6
              name={iconName}
              size={24}
              color={Colors.bubbleColor}
            />
          ) : iconLibrary === "MaterialCommunityIcons" ? (
            <MaterialCommunityIcons
              name={iconName ?? "magnify-plus-outline"}
              size={34}
              color={Colors.bubbleColor}
            />
          ) : (
            <SimpleLineIcons
              name="magnifier-add"
              size={24}
              color={Colors.bubbleColor}
            />
          )}
        </View>
      </View>
      <Text
        style={[
          screenSize === "small" ? Fonts.medium16 : Fonts.medium16,
          {
            textAlign: "center",
            color: Colors.blackColor,
            marginTop: 32,
          },
        ]}
      >
        {t(mainText)}
      </Text>
      <Text
        style={[
          screenSize === "small" ? Fonts.regular14 : Fonts.regular14,
          {
            textAlign: "center",
            color: Colors.grayColor,
            marginTop: 8,
            maxWidth: 380,
          },
        ]}
      >
        {t(subText)}
      </Text>
      {ctaText && onCtaPress && (
        <TouchableOpacity
          onPress={onCtaPress}
          onMouseEnter={() => !isMobile && setIsCtaHovered(true)}
          onMouseLeave={() => setIsCtaHovered(false)}
          style={{
            marginTop: 24,
            backgroundColor: Colors.bubbleColor,
            paddingVertical: 10,
            paddingHorizontal: 16,
            borderRadius: 12,
            alignItems: "center",
            justifyContent: "center",
            opacity: isCtaHovered ? 0.6 : 1,
          }}
        >
          <Text
            style={[
              {
                fontSize: 14,
                color: Colors.whiteColor,
              },
            ]}
          >
            {t(ctaText)}
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};
export default IconEmptyView;
